module.exports = __webpack_public_path__ + "static/media/winfinity.88e2e619.webp";